// Job Search Result Limits
export enum JobSearchLimit {
  WEB = 40,
  MOBILE = 40,
}
